const i18n = {
  'en-US': {
    'upload.excel.title': 'Upload Excel',
    'upload.excel.error': 'Upload failed',
    'upload.excel.importing': 'Importing, please wait...',
    'upload.excel.import.success': 'Import successful',
    'upload.excel.import.failed': 'Import failed'
  },
  'zh-CN': {
    'upload.excel.title': '上传表格',
    'upload.excel.error': '上传失败',
    'upload.excel.importing': '正在导入，请稍候...',
    'upload.excel.import.success': '导入成功',
    'upload.excel.import.failed': '导入失败'
  }
};
export default i18n;